// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form.signup-form .signup-form-field {
  width: calc(70% - 20px);
}
form.signup-form app-tooltip {
  padding: 2px;
}
form.signup-form .m-b-20 {
  display: flex;
  justify-content: left;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/signup-form/signup-form.component.scss"],"names":[],"mappings":"AACI;EACI,uBAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,aAAA;EACA,qBAAA;AAFR","sourcesContent":["form.signup-form {\n    .signup-form-field {\n        width: calc(70% - 20px);\n    }\n    \n    app-tooltip {\n        padding: 2px;\n    }\n    \n    .m-b-20 {\n        display: flex;\n        justify-content: left;\n    }    \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
